import { useContext } from 'react';

import { QuestionCommentContext } from './question-comment-provider';

export function useQuestionComment() {
  const context = useContext(QuestionCommentContext);

  if (!context) {
    throw new Error('useQuestionComment must be used within a QuestionCommentProvider');
  }

  return context;
}
